import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/icons/tap.svg';
import _imports_1 from '@/assets/icons/click.svg';
import _imports_2 from '@/assets/mintview/timer/starmap-outer-circle.svg';
import _imports_3 from '@/assets/mintview/timer/starmap-base.svg';
import _imports_4 from '@/assets/mintview/timer/small-clock.svg';
import _imports_5 from '@/assets/mintview/timer/timer-vertical-lines.svg';
import _imports_6 from '@/assets/mintview/timer/vertical-lines.svg';
import _imports_7 from '@/assets/mintview/timer/half-circle.svg';
import _imports_8 from '@/assets/mintview/timer/clock.svg';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "mask"
}, null, -1);
const _hoisted_2 = {
  key: 0,
  class: "close-info-container vertical"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "info"
}, "Tap anywhere to begin", -1);
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  key: 1,
  class: "close-info-container"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1
}, null, -1);
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  class: "info"
}, "Click anywhere to begin", -1);
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"starmap-container\"><div class=\"starmap-outer-circle-wrapper wrapper\"><img class=\"starmap-outer-circle\" src=\"" + _imports_2 + "\"></div><div class=\"starmap-base-wrapper wrapper\"><img class=\"starmap-base\" src=\"" + _imports_3 + "\"></div><div class=\"small-clock-wrapper wrapper\"><img class=\"small-clock\" src=\"" + _imports_4 + "\"></div></div>", 1);
const _hoisted_11 = {
  class: "timer-container wrapper"
};
const _hoisted_12 = {
  class: "timer"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "D", -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "H", -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "M", -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "timer-vertical-lines",
  src: _imports_5
}, null, -1);
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"vertical-lines-wrapper wrapper\"><img class=\"vertical-lines\" src=\"" + _imports_6 + "\"></div><div class=\"half-circle-wrapper wrapper\"><img class=\"half-circle\" src=\"" + _imports_7 + "\"></div><div class=\"clock-wrapper wrapper\"><img class=\"clock\" src=\"" + _imports_8 + "\"></div>", 3);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "countdown-timer-container",
    onClick: _cache[0] || (_cache[0] = () => _ctx.isCountDownOver && _ctx.close())
  }, [_hoisted_1, _ctx.isVerticalScreen && _ctx.isCountDownOver ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5)) : _ctx.isCountDownOver ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)) : _createCommentVNode("", true), _hoisted_10, _createElementVNode("div", {
    class: _normalizeClass(["clock-container", {
      vertical: _ctx.isVerticalScreen
    }])
  }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, [_createTextVNode(_toDisplayString(_ctx.countDown.days), 1), _hoisted_13, _createTextVNode(":" + _toDisplayString(_ctx.countDown.hours), 1), _hoisted_14, _createTextVNode(":" + _toDisplayString(_ctx.countDown.minutes), 1), _hoisted_15]), _hoisted_16]), _hoisted_17], 2)]);
}